module.exports = __webpack_public_path__ + "img/no_data.2533e400.png";